import { render } from "./SfActivityMain.vue?vue&type=template&id=3171d8e8&ts=true"
import script from "./SfActivityMain.vue?vue&type=script&lang=ts"
export * from "./SfActivityMain.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__